// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__Uuz61","label":"CategoryService_label__3cCtW","location":"CategoryService_location__B9RqK"};